import { isNil, prop, compose, cond, equals, always, T, path, length, lte } from 'ramda';

const oldPathToBounds = path([ 'units', 0, 'kg', 'bounds' ])

const lengthOfUnitsIsOne = compose(lte(1), length, prop('units'))
const firstUnitOfMeasure = path([ 'units', 0, 'bounds' ])

const extractBoundsFromNewStructure = cond([
  [ lengthOfUnitsIsOne, firstUnitOfMeasure ],
  [ T, oldPathToBounds ]
])

const extractBounds = cond([
  [ (meta) => isNil(oldPathToBounds(meta)), extractBoundsFromNewStructure ],
  [ T, oldPathToBounds ]
])

const minMax = compose(
  cond([ [ equals(undefined), always({}) ], [ T, extractBounds ] ]),
  prop('meta'))

export default minMax;



// WEBPACK FOOTER //
// ./src/components/questionnaire/validators/minMaxExtractor.js